import { Injectable } from '@angular/core';

@Injectable()
export class IndexedDBWrapper {
  private version: number = 2;
  public db: IDBDatabase;

  constructor() {}

  // WebSQL benzeri transaction yapısı için wrapper
  async openDatabase(databaseName: string, version: string, description: string, size: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(databaseName, this.version);
      
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        this.db = request.result;
        console.log('IndexedDB bağlantısı kuruldu:', databaseName);
        resolve(this);
      };
      
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        this.createTables(db);
        console.log('IndexedDB tabloları oluşturuldu');
      };
    });
  }

  private createTables(db: IDBDatabase) {
    console.log('Mevcut object store\'lar:', Array.from(db.objectStoreNames));
    
    // NL_Siparis tablosu
    if (!db.objectStoreNames.contains('NL_Siparis')) {
      console.log('NL_Siparis object store oluşturuluyor...');
      const nlSiparisStore = db.createObjectStore('NL_Siparis', { keyPath: 'ID', autoIncrement: true });
      nlSiparisStore.createIndex('StokKodu', 'StokKodu', { unique: false });
      nlSiparisStore.createIndex('CariKodu', 'CariKodu', { unique: false });
    }

    // M_SIPARIS_DETAY tablosu
    if (!db.objectStoreNames.contains('M_SIPARIS_DETAY')) {
      console.log('M_SIPARIS_DETAY object store oluşturuluyor...');
      const mSiparisDetayStore = db.createObjectStore('M_SIPARIS_DETAY', { keyPath: 'ID', autoIncrement: true });
      mSiparisDetayStore.createIndex('StokKartID', 'StokKartID', { unique: false });
      mSiparisDetayStore.createIndex('FaturaID', 'FaturaID', { unique: false });
    }

    // NL_Servis tablosu
    if (!db.objectStoreNames.contains('NL_Servis')) {
      console.log('NL_Servis object store oluşturuluyor...');
      db.createObjectStore('NL_Servis', { keyPath: 'ID', autoIncrement: true });
    }

    // NL_MalKabul tablosu
    if (!db.objectStoreNames.contains('NL_MalKabul')) {
      console.log('NL_MalKabul object store oluşturuluyor...');
      const nlMalKabulStore = db.createObjectStore('NL_MalKabul', { keyPath: 'ID', autoIncrement: true });
      nlMalKabulStore.createIndex('FISNO', 'FISNO', { unique: false });
    }

    // App_User tablosu
    if (!db.objectStoreNames.contains('App_User')) {
      console.log('App_User object store oluşturuluyor...');
      db.createObjectStore('App_User', { keyPath: 'ID', autoIncrement: true });
    }

    // NL_ProgramAyarlari tablosu
    if (!db.objectStoreNames.contains('NL_ProgramAyarlari')) {
      console.log('NL_ProgramAyarlari object store oluşturuluyor...');
      db.createObjectStore('NL_ProgramAyarlari', { keyPath: 'ID', autoIncrement: true });
    }

    // M_REMEMBER_ACC tablosu
    if (!db.objectStoreNames.contains('M_REMEMBER_ACC')) {
      console.log('M_REMEMBER_ACC object store oluşturuluyor...');
      db.createObjectStore('M_REMEMBER_ACC', { keyPath: 'ID', autoIncrement: true });
    }
    
    console.log('Tüm object store\'lar oluşturuldu:', Array.from(db.objectStoreNames));
  }

  // WebSQL transaction benzeri yapı
  transaction(callback: (tx: IndexedDBTransaction) => void): void {
    if (!this.db) {
      console.error('Database not initialized. Call openDatabase first.');
      return;
    }
    
    // Object store'ların mevcut olduğunu kontrol et
    const requiredStores = ['NL_Siparis', 'M_SIPARIS_DETAY', 'NL_Servis', 'NL_MalKabul', 'App_User', 'NL_ProgramAyarlari', 'M_REMEMBER_ACC'];
    const missingStores = requiredStores.filter(store => !this.db.objectStoreNames.contains(store));
    
    if (missingStores.length > 0) {
      console.error('Eksik object store\'lar:', missingStores);
      console.error('Mevcut object store\'lar:', Array.from(this.db.objectStoreNames));
      // Veritabanını yeniden oluştur
      this.recreateDatabase();
      return;
    }
    
    const tx = new IndexedDBTransaction(this.db);
    callback(tx);
  }

  // Veritabanını yeniden oluştur
  private recreateDatabase(): void {
    console.log('Veritabanı yeniden oluşturuluyor...');
    const deleteRequest = indexedDB.deleteDatabase('M724DB');
    deleteRequest.onsuccess = () => {
      console.log('Eski veritabanı silindi, yeniden oluşturuluyor...');
      this.openDatabase('M724DB', "", "", 25 * 1024 * 1024);
    };
    deleteRequest.onerror = () => {
      console.error('Veritabanı silinemedi:', deleteRequest.error);
    };
  }

  // WebSQL executeSql benzeri metod
  executeSql(sql: string, params: any[] = [], successCallback?: (tx: any, result: any) => void, errorCallback?: (tx: any, error: any) => void): void {
    if (!this.db) {
      console.error('Database not initialized. Call openDatabase first.');
      if (errorCallback) errorCallback(null, new Error('Database not initialized'));
      return;
    }
    const tx = new IndexedDBTransaction(this.db);
    tx.executeSql(sql, params, successCallback, errorCallback);
  }
}

// WebSQL transaction benzeri sınıf
class IndexedDBTransaction {
  private db: IDBDatabase;

  constructor(db: IDBDatabase) {
    this.db = db;
  }

  executeSql(sql: string, params: any[] = [], successCallback?: (tx: any, result: any) => void, errorCallback?: (tx: any, error: any) => void): void {
    try {
      const operation = this.parseSQL(sql);
      
      switch (operation.type) {
        case 'SELECT':
          this.handleSelect(operation, params, successCallback, errorCallback);
          break;
        case 'INSERT':
          this.handleInsert(operation, params, successCallback, errorCallback);
          break;
        case 'UPDATE':
          this.handleUpdate(operation, params, successCallback, errorCallback);
          break;
        case 'DELETE':
          this.handleDelete(operation, params, successCallback, errorCallback);
          break;
        case 'CREATE':
          this.handleCreate(operation, successCallback, errorCallback);
          break;
        default:
          if (errorCallback) errorCallback(this, new Error('Unsupported SQL operation'));
      }
    } catch (error) {
      if (errorCallback) errorCallback(this, error);
    }
  }

  private parseSQL(sql: string): any {
    const trimmed = sql.trim().toUpperCase();
    
    if (trimmed.startsWith('SELECT')) {
      return this.parseSelect(sql);
    } else if (trimmed.startsWith('INSERT')) {
      return this.parseInsert(sql);
    } else if (trimmed.startsWith('UPDATE')) {
      return this.parseUpdate(sql);
    } else if (trimmed.startsWith('DELETE')) {
      return this.parseDelete(sql);
    } else if (trimmed.startsWith('CREATE')) {
      return this.parseCreate(sql);
    }
    
    throw new Error('Unsupported SQL operation');
  }

  private parseSelect(sql: string): any {
    const match = sql.match(/SELECT\s+(.*?)\s+FROM\s+(\w+)(?:\s+WHERE\s+(.*))?/i);
    if (!match) throw new Error('Invalid SELECT statement');
    
    return {
      type: 'SELECT',
      columns: match[1].split(',').map(col => col.trim()),
      table: match[2],
      where: match[3] || null
    };
  }

  private parseInsert(sql: string): any {
    const match = sql.match(/INSERT\s+INTO\s+(\w+)\s*\(([^)]+)\)\s*VALUES\s*\(([^)]+)\)/i);
    if (!match) throw new Error('Invalid INSERT statement');
    
    return {
      type: 'INSERT',
      table: match[1],
      columns: match[2].split(',').map(col => col.trim()),
      values: match[3].split(',').map(val => val.trim())
    };
  }

  private parseUpdate(sql: string): any {
    const match = sql.match(/UPDATE\s+(\w+)\s+SET\s+(.*?)(?:\s+WHERE\s+(.*))?/i);
    if (!match) throw new Error('Invalid UPDATE statement');
    
    return {
      type: 'UPDATE',
      table: match[1],
      set: match[2],
      where: match[3] || null
    };
  }

  private parseDelete(sql: string): any {
    const match = sql.match(/DELETE\s+FROM\s+(\w+)(?:\s+WHERE\s+(.*))?/i);
    if (!match) throw new Error('Invalid DELETE statement');
    
    return {
      type: 'DELETE',
      table: match[1],
      where: match[2] || null
    };
  }

  private parseCreate(sql: string): any {
    const match = sql.match(/CREATE\s+TABLE\s+IF\s+NOT\s+EXISTS\s+(\w+)/i);
    if (!match) throw new Error('Invalid CREATE statement');
    
    return {
      type: 'CREATE',
      table: match[1]
    };
  }

  private async handleSelect(operation: any, params: any[], successCallback?: any, errorCallback?: any): Promise<void> {
    try {
      const transaction = this.db.transaction([operation.table], 'readonly');
      const store = transaction.objectStore(operation.table);
      const request = store.openCursor();
      const results: any[] = [];
      
      request.onsuccess = (event) => {
        const cursor = (event.target as IDBRequest).result;
        if (cursor) {
          results.push(cursor.value);
          cursor.continue();
        } else {
          const filteredResults = this.applyWhereClause(results, operation.where, params);
          
          const mockResult = {
            rows: {
              length: filteredResults.length,
              item: (index: number) => filteredResults[index]
            }
          };
          
          if (successCallback) successCallback(this, mockResult);
        }
      };
      
      request.onerror = () => {
        if (errorCallback) errorCallback(this, request.error);
      };
    } catch (error) {
      if (errorCallback) errorCallback(this, error);
    }
  }

  private async handleInsert(operation: any, params: any[], successCallback?: any, errorCallback?: any): Promise<void> {
    try {
      const transaction = this.db.transaction([operation.table], 'readwrite');
      const store = transaction.objectStore(operation.table);
      
      const data: any = {};
      operation.columns.forEach((col: string, index: number) => {
        data[col] = params[index] || null;
      });
      
      const request = store.add(data);
      
      request.onsuccess = () => {
        const mockResult = {
          insertId: request.result
        };
        if (successCallback) successCallback(this, mockResult);
      };
      
      request.onerror = () => {
        if (errorCallback) errorCallback(this, request.error);
      };
    } catch (error) {
      if (errorCallback) errorCallback(this, error);
    }
  }

  private async handleUpdate(operation: any, params: any[], successCallback?: any, errorCallback?: any): Promise<void> {
    try {
      const transaction = this.db.transaction([operation.table], 'readwrite');
      const store = transaction.objectStore(operation.table);
      
      // Önce tüm kayıtları al
      const cursorRequest = store.openCursor();
      const allRecords: any[] = [];
      
      cursorRequest.onsuccess = (event) => {
        const cursor = (event.target as IDBRequest).result;
        if (cursor) {
          allRecords.push(cursor.value);
          cursor.continue();
        } else {
          const updatedRecords = this.applyUpdate(allRecords, operation, params);
          
          // Güncellenmiş kayıtları geri yaz
          const putPromises = updatedRecords.map(record => {
            return new Promise((resolve, reject) => {
              const putRequest = store.put(record);
              putRequest.onsuccess = () => resolve(putRequest.result);
              putRequest.onerror = () => reject(putRequest.error);
            });
          });
          
          Promise.all(putPromises).then(() => {
            if (successCallback) successCallback(this, { rowsAffected: updatedRecords.length });
          }).catch(error => {
            if (errorCallback) errorCallback(this, error);
          });
        }
      };
      
      cursorRequest.onerror = () => {
        if (errorCallback) errorCallback(this, cursorRequest.error);
      };
    } catch (error) {
      if (errorCallback) errorCallback(this, error);
    }
  }

  private async handleDelete(operation: any, params: any[], successCallback?: any, errorCallback?: any): Promise<void> {
    try {
      const transaction = this.db.transaction([operation.table], 'readwrite');
      const store = transaction.objectStore(operation.table);
      
      if (!operation.where) {
        // Tüm kayıtları sil
        const clearRequest = store.clear();
        clearRequest.onsuccess = () => {
          if (successCallback) successCallback(this, { rowsAffected: 0 });
        };
        clearRequest.onerror = () => {
          if (errorCallback) errorCallback(this, clearRequest.error);
        };
      } else {
        // WHERE koşuluna göre sil
        const cursorRequest = store.openCursor();
        const allRecords: any[] = [];
        
        cursorRequest.onsuccess = (event) => {
          const cursor = (event.target as IDBRequest).result;
          if (cursor) {
            allRecords.push(cursor.value);
            cursor.continue();
          } else {
            const recordsToDelete = this.applyWhereClause(allRecords, operation.where, params);
            
            const deletePromises = recordsToDelete.map(record => {
              return new Promise((resolve, reject) => {
                const deleteRequest = store.delete(record.ID);
                deleteRequest.onsuccess = () => resolve(deleteRequest.result);
                deleteRequest.onerror = () => reject(deleteRequest.error);
              });
            });
            
            Promise.all(deletePromises).then(() => {
              if (successCallback) successCallback(this, { rowsAffected: recordsToDelete.length });
            }).catch(error => {
              if (errorCallback) errorCallback(this, error);
            });
          }
        };
        
        cursorRequest.onerror = () => {
          if (errorCallback) errorCallback(this, cursorRequest.error);
        };
      }
    } catch (error) {
      if (errorCallback) errorCallback(this, error);
    }
  }

  private async handleCreate(operation: any, successCallback?: any, errorCallback?: any): Promise<void> {
    // CREATE TABLE işlemi zaten onupgradeneeded'de yapılıyor
    if (successCallback) successCallback(this, {});
  }

  private applyWhereClause(records: any[], whereClause: string, params: any[]): any[] {
    if (!whereClause) return records;
    
    return records.filter(record => {
      // WHERE koşulunu işle
      const conditions = whereClause.split(' AND ');
      return conditions.every(condition => {
        const trimmed = condition.trim();
        
        // ? parametresi kontrolü
        if (trimmed.includes('=?')) {
          const [field] = trimmed.split('=?');
          const paramIndex = trimmed.split('?').length - 2;
          return record[field] == params[paramIndex];
        }
        
        // Normal değer kontrolü
        const match = trimmed.match(/(\w+)\s*=\s*['"]?([^'"]*)['"]?/);
        if (match) {
          const [, field, value] = match;
          return record[field] == value;
        }
        
        return true;
      });
    });
  }

  private applyUpdate(records: any[], operation: any, params: any[]): any[] {
    const setClause = operation.set;
    const setPairs = setClause.split(',').map(pair => {
      const [field, value] = pair.trim().split('=');
      return { field: field.trim(), value: value.trim() };
    });
    
    return records.map(record => {
      const updatedRecord = { ...record };
      setPairs.forEach(pair => {
        if (pair.value === '?') {
          // Parametre değeri kullan
          const paramIndex = setPairs.indexOf(pair);
          updatedRecord[pair.field] = params[paramIndex];
        } else {
          updatedRecord[pair.field] = pair.value.replace(/'/g, '');
        }
      });
      return updatedRecord;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/indexeddb-wrapper.ts